// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-toggle::after {
  display: none !important;
}

.dropdown-toggle {
  background-color: #2D2C57 !important;
}

.dropdown img {
  vertical-align: bottom;
}

.userPic {
  vertical-align: bottom;
  width: 24px;
  height: 24px;
  border-radius: 100%;
  overflow: hidden;
  object-fit: cover;
  margin-right: 0.5rem;
}

.brand img {
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/styles/header.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;AAAF;;AAEA;EACE,oCAAA;AACF;;AACA;EACE,sBAAA;AAEF;;AAAA;EACE,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACE,oBAAA;AAGJ;;AACE;EACE,YAAA;AAEJ","sourcesContent":["@import './colors';\n.dropdown-toggle::after{\n  display:none !important;\n}\n.dropdown-toggle{\n  background-color: #2D2C57 !important;\n}\n.dropdown img{\n  vertical-align: bottom;\n}\n.userPic{\n  vertical-align: bottom;\n  width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  overflow: hidden;\n  object-fit: cover;\n    margin-right: 0.5rem;\n}\n\n.brand {\n  img {\n    height: 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
